export const ships = [
  {
    id: 253,
    name: 'bike_4',
    icon: 'Truck',
    type: 1,
    title: 'ارسال با پیک',
    cities: {
      included: ['tehran'],
      not_included: [],
    },
    exp: 'هزینه ارسال به شماره همراه شما پیامک می‌شود.',
  },
  {
    id: 251,
    name: 'bike_3',
    type: 0,
    icon: 'Box',
    title: 'پست و تیپاکس',
    cities: {
      included: [],
      not_included: ['tehran'],
    },
  },
  {
    id: 252,
    name: 'in_person',
    icon: 'InPersonDelivery',
    type: 1,
    title: 'تحویل حضوری',
    cities: {
      included: ['tehran'],
      not_included: [],
    },
    exp: 'ارسال سریع بلافاصله بعد از سفارش، هزینه ارسال به شماره همراه شما پیامک می‌شود.',
  },

  {
    id: 250,
    name: 'free',
    icon: 'Box',
    type: 0,
    title: 'ارسال رایگان',
    cities: {
      included: [],
      not_included: [''],
    },
  },
];
